var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1.5C1.72386 1.5 1.5 1.72386 1.5 2V14C1.5 14.2761 1.72386 14.5 2 14.5H14C14.2761 14.5 14.5 14.2761 14.5 14V10.3333C14.5 10.0572 14.7239 9.83333 15 9.83333C15.2761 9.83333 15.5 10.0572 15.5 10.3333V14C15.5 14.8284 14.8284 15.5 14 15.5H2C1.17157 15.5 0.5 14.8284 0.5 14V2C0.5 1.17157 1.17157 0.5 2 0.5H7C7.27614 0.5 7.5 0.723858 7.5 1C7.5 1.27614 7.27614 1.5 7 1.5H2Z",
    fill: "#1D1D46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-path": "fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.4004C8.27614 10.4004 8.5 10.1765 8.5 9.90039V6.50039C8.5 5.67196 9.17157 5.00039 10 5.00039H13.7929L12.1464 6.64684C11.9512 6.8421 11.9512 7.15868 12.1464 7.35394C12.3417 7.54921 12.6583 7.54921 12.8536 7.35394L15.7071 4.50039L12.8536 1.64684C12.6583 1.45158 12.3417 1.45158 12.1464 1.64684C11.9512 1.8421 11.9512 2.15868 12.1464 2.35394L13.7929 4.00039H10C8.61929 4.00039 7.5 5.11968 7.5 6.50039V9.90039C7.5 10.1765 7.72386 10.4004 8 10.4004Z",
    fill: "#1D1D46"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToCompany);
export default __webpack_public_path__ + "static/media/to-company.b5a1f7ebe6f766d2ce9e84eb5a1640f3.svg";
export { ForwardRef as ReactComponent };